var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneMob(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_485_1275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 12.1176V14.1176C14.6672 14.3033 14.6292 14.4871 14.5548 14.6572C14.4804 14.8273 14.3713 14.98 14.2345 15.1055C14.0977 15.2311 13.9362 15.3266 13.7603 15.3861C13.5844 15.4456 13.398 15.4677 13.2131 15.451C11.1617 15.2281 9.19113 14.5271 7.45979 13.4043C5.84901 12.3807 4.48335 11.0151 3.45979 9.4043C2.33311 7.6651 1.63195 5.68496 1.41313 3.6243C1.39647 3.43994 1.41838 3.25414 1.47746 3.07871C1.53654 2.90329 1.63151 2.74209 1.7563 2.60538C1.8811 2.46867 2.033 2.35944 2.20232 2.28464C2.37164 2.20985 2.55469 2.17114 2.73979 2.17096H4.73979C5.06333 2.16778 5.37699 2.28235 5.6223 2.49332C5.86761 2.70429 6.02784 2.99726 6.07313 3.31763C6.15754 3.95767 6.31409 4.58611 6.53979 5.19096C6.62949 5.42958 6.6489 5.68891 6.59573 5.93822C6.54256 6.18753 6.41903 6.41637 6.23979 6.59763L5.39313 7.4443C6.34216 9.11333 7.7241 10.4953 9.39313 11.4443L10.2398 10.5976C10.4211 10.4184 10.6499 10.2949 10.8992 10.2417C11.1485 10.1885 11.4078 10.2079 11.6465 10.2976C12.2513 10.5233 12.8797 10.6799 13.5198 10.7643C13.8436 10.81 14.1394 10.9731 14.3508 11.2226C14.5622 11.4722 14.6746 11.7907 14.6665 12.1176Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_1275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.837891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMob);
export default __webpack_public_path__ + "static/media/phoneMob.170de35df43791dd205ab618dc7f118c.svg";
export { ForwardRef as ReactComponent };